document.addEventListener("DOMContentLoaded", function () {
  setTimeout(function () {
    const radioInputs = document.querySelectorAll(
      ".bold_option.bold_option_radio .bold_option_value_element input"
    );
    const swatchInputs = document.querySelectorAll(
      ".bold_option.bold_option_swatch .bold_option_value_element input"
    );
    const thumbnailImages = document.querySelectorAll(
      ".product-gallery__thumbnail img"
    );
    const productImages = document.querySelectorAll(".product-gallery__media");
    const defaultSwatches = document.querySelectorAll(".thumbnail-swatch");

    function handleChange(event) {
      const boldValue = event.target.value.toLowerCase();
      var firstProduct, secondProduct, temp;
      firstProduct = productImages[0];
      temp = firstProduct.innerHTML;

      // click thumbnail if match found
      thumbnailImages.forEach(function (image) {
        const imgValue = image.getAttribute("alt")?.toLowerCase();
        if (boldValue === imgValue) {
          image.parentElement.click();
        }
      });

      // swap main image
      // productImages.forEach(function (image, index) {
      //   if (index === 0) return;
      //   const imgTag = image.querySelector("img");
      //   if (!imgTag) return;

      //   secondProduct = image;
      //   const imgValue = imgTag.getAttribute("alt")?.toLowerCase();
      //   if (boldValue === imgValue) {
      //     firstProduct.innerHTML = secondProduct.innerHTML;
      //     secondProduct.innerHTML = temp;
      //   }
      // });
    }


    radioInputs.forEach(input => input.addEventListener("change", handleChange));
    swatchInputs.forEach(input => input.addEventListener("change", handleChange));

  }, 2000);
});
